import { Blogtable } from "../../components/datatable/Blogtable";

const Blog = () => {
  return <Blogtable />;
};

export default Blog;
